import axiosService from '@/services/axios/axios.service';
import {
    IGetRequestWFH,
    IGetWFHResponse,
    IUpdateWFH,
} from '@/models/wfh.model';

const getWfh = async (
    payload: IGetRequestWFH
): Promise<NonNullable<IGetWFHResponse>> => {
    const response = await axiosService.get('/wfh/get-wfh-by-admin', {
        params: payload,
    });
    return response.data;
};

/**
 * update wfh
 * @Post('update-wfh')
  @UseGuards(JwtGuard)
  @UseGuards(RoleGuard)
  @Roles(UserRole.ADMIN)
  async updateWFH(@Body() body: { requestId: string; decision: string; note: string; originalMessageTs: string }) {
    return this.wfhService.updateRequestWFH({
      requestId: body.requestId,
      decision: body.decision,
      note: body.note,
      originalMessageTs: body.originalMessageTs,
    });
  }
 */

const updateWfh = async (payload: IUpdateWFH) => {
    const response = await axiosService.post('/wfh/update-wfh', payload);
    return response.data;
};

export { getWfh, updateWfh };
